webpackJsonp([32],{

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_1af4460e___ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(16);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_1af4460e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_1af4460e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_1af4460e___ = __webpack_require__(124);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_1af4460e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_1af4460e___["b"]; });


/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(!_vm.isAuthenticated)?_c('div',[_c('router-view')],1):(_vm.isAuthenticated)?_c('div',[_c('app-drawer'),_vm._v(" "),_c('app-toolbar'),_vm._v(" "),_c('app-view')],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","width":"500px"},model:{value:(_vm.showNotice),callback:function ($$v) {_vm.showNotice=$$v},expression:"showNotice"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n                Aviso\n            ")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Bienvenido al nuevo Portal de Estudiantes del ITTG.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    Agradecemos tu interés en ayudarnos a reportar los errores que encuentres, así como las sugerencias que tengas y puedan\n                    colaborar en el desarrollo y mejora continua de este portal.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    Puedes enviar tus reportes al siguiente correo "),_c('b',[_vm._v("appestudiantes@ittg.edu.mx")]),_vm._v(" anexando tu Nombre, No. de Control, Descripción del problema y capturas de pantalla.\n                ")]),_vm._v("\n\n                Gracias por tu participación.\n            ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green","flat":""},on:{"click":function($event){_vm.showNotice = false}}},[_vm._v("\n                    Aceptar\n                ")])],1)],1)],1)],1)
}
var staticRenderFns = []



/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppDrawer_vue_vue_type_template_id_75c3694a___ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppDrawer_vue_vue_type_script_lang_js___ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(16);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AppDrawer_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__AppDrawer_vue_vue_type_template_id_75c3694a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AppDrawer_vue_vue_type_template_id_75c3694a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_AppDrawer_vue_vue_type_template_id_75c3694a___ = __webpack_require__(165);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_AppDrawer_vue_vue_type_template_id_75c3694a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_AppDrawer_vue_vue_type_template_id_75c3694a___["b"]; });


/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"fixed":"","clipped":_vm.$vuetify.breakpoint.lgAndUp,"app":"","mobile-break-point":1281},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},[_c('v-list',{attrs:{"dense":"","expand":""}},[_c('v-list-tile',{attrs:{"to":'/',"ripple":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("home")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                    Inicio\n                ")])],1)],1),_vm._v(" "),_vm._l((_vm.items),function(item){return [(item.items)?_c('v-list-group',{attrs:{"group":item.group,"no-action":""}},[_c('v-list-tile',{attrs:{"slot":"activator","ripple":""},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                            "+_vm._s(item.title)+"\n                        ")])],1)],1),_vm._v(" "),_vm._l((item.items),function(subItem,i){return [(subItem.items)?_c('v-list-group',{attrs:{"group":subItem.group,"sub-group":""}},[_c('v-list-tile',{attrs:{"slot":"activator","ripple":""},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                                    "+_vm._s(subItem.title)+"\n                                ")])],1)],1),_vm._v(" "),_vm._l((subItem.items),function(grand,i){return _c('v-list-tile',{key:i,attrs:{"to":_vm.genChildTarget(item, grand),"href":grand.href,"ripple":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                                    "+_vm._s(grand.title)+"\n                                ")])],1)],1)})],2):_c('v-list-tile',{key:i,attrs:{"to":_vm.genChildTarget(item, subItem),"href":subItem.href,"target":subItem.target,"ripple":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                                "+_vm._s(subItem.title)+"\n                            ")])],1)],1)]})],2):_c('v-list-tile',{attrs:{"ripple":"","to":!item.href ? { name: item.name } : null,"href":item.href,"disabled":item.disabled,"target":item.target,"rel":"noopener"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                        "+_vm._s(item.title)+"\n                    ")])],1)],1)]}),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.togglePush}},[_c('v-list-tile-action',[(_vm.isPushEnabled)?_c('v-icon',[_vm._v("notifications_active")]):_c('v-icon',[_vm._v("notifications_none")])],1),_vm._v(" "),_c('v-list-tile-content',[(_vm.isPushEnabled)?_c('v-list-tile-title',[_vm._v("\n                    Desactivar Notificaciones\n                ")]):_c('v-list-tile-title',[_vm._v("\n                    Activar Notificaciones\n                ")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.logout}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                    Cerrar Sesión\n                ")])],1)],1)],2)],1)
}
var staticRenderFns = []



/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  title: 'Información Escolar',
  group: 'information',
  items: [{
    title: 'Mi Información',
    group: '(personal|familiar|socioeconomica|trabajo)',
    namespace: 'information',
    items: [{
      name: 'personal',
      title: 'Personal'
    }, {
      name: 'familiar',
      title: 'Familiar'
    }, {
      name: 'socioeconomica',
      title: 'Socioeconómica'
    }, {
      name: 'trabajo',
      title: 'Trabajo'
    }]
  }, {
    title: 'Servicio Social',
    group: '(servicio-social)',
    namespace: 'information',
    items: [{
      name: 'servicio-social',
      title: 'Realizar Solicitud'
    }, {
      name: 'servicio-social-descargas',
      title: 'Descargas'
    }, {
      name: 'servicio-social-reportes',
      title: 'Reportes'
    }]
  }, {
    title: 'Residencia',
    group: '(residencia-profesional)',
    namespace: 'information',
    items: [{
      name: 'residencia-profesional',
      title: 'Solicitud de Residencia Profesional'
    }, {
      name: 'residencia-profesional-descargas',
      title: 'Descargas'
    }]
  }, {
    name: 'boleta',
    title: 'Boleta de Calificaciones'
  }, {
    name: 'horario',
    title: 'Horario'
  }, {
    name: 'kardex',
    title: 'Kardex'
  }, {
    name: 'avance-reticular',
    title: 'Avance Reticular'
  }, {
    name: 'calificaciones-parciales',
    title: 'Calificaciones Parciales'
  }, {
    name: 'instrumentacion-didactica',
    title: 'Instrumentación Didáctica'
  }, {
    name: 'gestion-curso',
    title: 'Gestion del Curso'
  }]
}, {
  title: 'Inscripciones',
  group: 'inscripciones',
  items: [{
    name: 'referencia-bancaria',
    title: 'Referencia Bancaria'
  }, {
    name: 'grupos-disponibles',
    title: 'Grupos Disponibles'
  }, {
    name: 'reinscripcion',
    title: 'Reinscripción'
  }, {
    name: 'extra-escolar',
    title: 'ExtraEscolar'
  }, {
    name: 'verano',
    title: 'Pre-registro de Verano'
  }]
}, {
  title: 'Evaluacion docente',
  group: 'evaluacion-docente',
  items: [{
    name: 'evaluacion-docente',
    title: 'Realizar Evaluación'
  }, {
    name: 'evaluaciones-realizadas',
    title: 'Evaluaciones Realizadas'
  }]
}, {
  title: 'Documentos Oficiales',
  group: 'doctos-oficiales',
  items: [{
    name: 'solicitar',
    title: 'Solicitar'
  }, {
    name: 'consultar',
    title: 'Consultar'
  }]
}, {
  title: 'Encuesta de Servicios',
  name: 'EncuestaServicios',
  icon: 'playlist_add_check'
}, {
  title: 'Buzón de quejas y/o sugerencias',
  icon: 'mail',
  name: 'Buzon'
}]);

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = camel;
/* unused harmony export capitalize */
function camel(str) {
  var camel = (str || '').replace(/-([^-])/g, function (g) {
    return g[1].toUpperCase();
  });
  return capitalize(camel);
}
function capitalize(str) {
  str = str || '';
  return "".concat(str.substr(0, 1).toUpperCase()).concat(str.slice(1));
}

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppToolbar_vue_vue_type_template_id_2ffc1fd5_scoped_true___ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppToolbar_vue_vue_type_script_lang_js___ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(16);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AppToolbar_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__AppToolbar_vue_vue_type_template_id_2ffc1fd5_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AppToolbar_vue_vue_type_template_id_2ffc1fd5_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "2ffc1fd5",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_AppToolbar_vue_vue_type_template_id_2ffc1fd5_scoped_true___ = __webpack_require__(170);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_AppToolbar_vue_vue_type_template_id_2ffc1fd5_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_AppToolbar_vue_vue_type_template_id_2ffc1fd5_scoped_true___["b"]; });


/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{ref:"toolbar",attrs:{"color":"blue darken-4","dark":"","app":"","clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"fixed":""}},[_c('v-toolbar-title',{staticClass:"ml-0 pl-3"},[_c('v-toolbar-side-icon',{on:{"click":function($event){return _vm.$store.commit('DRAWER_TOGGLE')}}}),_vm._v(" "),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v("Portal de Estudiantes")]),_vm._v(" "),_c('span',{staticClass:"hidden-md-and-up"},[_vm._v("ITTG")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-menu',{attrs:{"bottom":"","left":"","offset-y":"","attach":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":""},slot:"activator"},[(!_vm.user.avatar)?_c('v-icon',{attrs:{"dark":""}},[_vm._v("account_circle")]):_vm._e(),_vm._v(" "),(_vm.user.avatar)?_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('img',{attrs:{"src":"https://vuetifyjs.com/static/doc-images/logo.svg","alt":"Vuetify"}})]):_vm._e()],1),_vm._v(" "),_c('v-list',{attrs:{"light":""}},[_c('v-list-tile',{on:{"click":_vm.logout}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"light":""}},[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v("Cerrar Sesión")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []



/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppView_vue_vue_type_template_id_43d958a7___ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppView_vue_vue_type_script_lang_js___ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppView_vue_vue_type_style_index_0_id_43d958a7_prod_lang_css___ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(16);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AppView_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__AppView_vue_vue_type_template_id_43d958a7___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AppView_vue_vue_type_template_id_43d958a7___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_AppView_vue_vue_type_template_id_43d958a7___ = __webpack_require__(173);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_AppView_vue_vue_type_template_id_43d958a7___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_AppView_vue_vue_type_template_id_43d958a7___["b"]; });


/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('router-view'),_vm._v(" "),_c('v-snackbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNewUpdateMessage),expression:"showNewUpdateMessage"}],attrs:{"top":true,"timeout":10000},model:{value:(_vm.showNewUpdateMessage),callback:function ($$v) {_vm.showNewUpdateMessage=$$v},expression:"showNewUpdateMessage"}},[_vm._v("\n        "+_vm._s(_vm.newUpdate.text)+"\n        "),_c('v-btn',{attrs:{"color":"pink","flat":""},on:{"click":_vm.reloadPage}},[_vm._v("\n            Recargar\n        ")])],1)],1)
}
var staticRenderFns = []



/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppView_vue_vue_type_style_index_0_id_43d958a7_prod_lang_css___ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppView_vue_vue_type_style_index_0_id_43d958a7_prod_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppView_vue_vue_type_style_index_0_id_43d958a7_prod_lang_css___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__catalogs__ = __webpack_require__(182);




/* harmony default export */ __webpack_exports__["a"] = ({
  app: __WEBPACK_IMPORTED_MODULE_0__app__["a" /* default */],
  auth: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */],
  user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
  catalogs: __WEBPACK_IMPORTED_MODULE_3__catalogs__["a" /* default */]
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

var _mutations, _actions;


var state = {
  appDrawer: null,
  showNewUpdateMessage: false,
  newUpdate: {
    text: '',
    secondary: false,
    showReloadButton: false,
    timeout: 0,
    onClick: function onClick() {}
  },
  pushNotificationEnabled: false
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["e" /* DRAWER */], function (state, payload) {
  state.appDrawer = payload;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["f" /* DRAWER_TOGGLE */], function (state) {
  state.appDrawer = !state.appDrawer;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["m" /* NEW_UPDATE */], function (state, payload) {
  state.showNewUpdateMessage = true;
  state.newUpdate = payload;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["n" /* PUSH_NOTIFICATION */], function (state, payload) {
  console.log(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["n" /* PUSH_NOTIFICATION */]);
  console.log(payload);
  state.pushNotificationEnabled = payload;
}), _mutations);
var getters = {
  getBaseURL: function getBaseURL() {
    return "https://estudiantes.tuxtla.tecnm.mx";
  },
  isPushEnabled: function isPushEnabled(state) {
    return state.pushNotificationEnabled;
  }
};
var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["m" /* NEW_UPDATE */], function (_ref, message) {
  var commit = _ref.commit;
  commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["m" /* NEW_UPDATE */], message);
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["o" /* PUSH_NOTIFICATION_UNSUBSCRIBE */], function (_ref2) {
  var commit = _ref2.commit;
  navigator.serviceWorker.ready.then(function (registration) {
    registration.pushManager.getSubscription().then(function (subscription) {
      if (!subscription) {
        commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["n" /* PUSH_NOTIFICATION */], false);
        return;
      }
      subscription.unsubscribe().then(function () {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/alumno/subscriptions/delete', {
          endpoint: subscription.endpoint
        });
        commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["n" /* PUSH_NOTIFICATION */], false);
      }).catch(function (e) {
        console.log('Unsubscription error: ', e);
      });
    }).catch(function (e) {
      console.log('Error thrown while unsubscribing.', e);
    });
  });
}), _actions);
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_promise__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios_index__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios_index__);

var _mutations, _actions;



var state = {
  token: localStorage.getItem('token') || '',
  status: ''
};
var getters = {
  isAuthenticated: function isAuthenticated(state) {
    return !!state.token;
  },
  authStatus: function authStatus(state) {
    return state.status;
  }
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["c" /* AUTH_REQUEST */], function (state) {
  state.status = 'loading';
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["d" /* AUTH_SUCCESS */], function (state, token) {
  state.status = 'success';
  state.token = token;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["a" /* AUTH_ERROR */], function (state) {
  state.status = 'error';
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["b" /* AUTH_LOGOUT */], function (state) {
  state.token = '';
}), _mutations);
var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["c" /* AUTH_REQUEST */], function (_ref, credentials) {
  var commit = _ref.commit,
    dispatch = _ref.dispatch;
  return new __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_promise___default.a(function (resolve, reject) {
    commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["c" /* AUTH_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_3_axios_index___default()({
      url: 'login',
      data: credentials,
      method: 'POST'
    }).then(function (resp) {
      var token = resp.data.token;
      localStorage.setItem('token', token);
      __WEBPACK_IMPORTED_MODULE_3_axios_index___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["d" /* AUTH_SUCCESS */], token);
      dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["j" /* FETCH_USER */]);
      resolve(resp);
    }).catch(function (err) {
      commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["a" /* AUTH_ERROR */], err);
      localStorage.removeItem('token');
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["b" /* AUTH_LOGOUT */], function (_ref2) {
  var commit = _ref2.commit,
    dispatch = _ref2.dispatch;
  return new __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_promise___default.a(function (resolve, reject) {
    localStorage.removeItem('token');
    localStorage.removeItem('profile');
    localStorage.clear();
    sessionStorage.clear();
    commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["b" /* AUTH_LOGOUT */]);
    resolve();
  });
}), _actions);
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(15);

var _mutations;




var state = {
  status: '',
  profile: JSON.parse(localStorage.getItem('profile')) || {}
};
var getters = {
  getProfile: function getProfile(state) {
    return state.profile;
  },
  isProfileLoaded: function isProfileLoaded(state) {
    return !!state.profile.nombreCompleto;
  }
};
var actions = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["j" /* FETCH_USER */], function (_ref) {
  var commit = _ref.commit,
    distpach = _ref.distpach;
  commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["j" /* FETCH_USER */]);
  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('alumno/perfil').then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["l" /* FETCH_USER_SUCCESS */], resp.data.alumno);
    localStorage.setItem('profile', __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_json_stringify___default()(resp.data.alumno));
  }).catch(function () {
    commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["k" /* FETCH_USER_FAILURE */]);
    distpach(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["b" /* AUTH_LOGOUT */]);
  });
});
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["j" /* FETCH_USER */], function (state) {
  state.status = 'loading';
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["l" /* FETCH_USER_SUCCESS */], function (state, resp) {
  state.status = 'success';
  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'profile', resp);
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["k" /* FETCH_USER_FAILURE */], function (state) {
  state.status = 'error';
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["b" /* AUTH_LOGOUT */], function (state) {
  state.profile = {};
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(15);

var _mutations;




var state = {
  listaEstados: JSON.parse(localStorage.getItem('listaEstados')) || [],
  status: ''
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["g" /* FETCH_CATALOGO_ESTADOS */], function (state) {
  state.status = 'loading';
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["i" /* FETCH_CATALOGO_ESTADOS_SUCCESS */], function (state, resp) {
  state.status = 'success';
  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'listaEstados', resp);
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["h" /* FETCH_CATALOGO_ESTADOS_FAILURE */], function (state) {
  state.status = 'error';
}), _mutations);
var actions = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["g" /* FETCH_CATALOGO_ESTADOS */], function (_ref) {
  var commit = _ref.commit,
    distpatch = _ref.distpatch;
  commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["g" /* FETCH_CATALOGO_ESTADOS */]);
  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('catalogo/estados').then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["i" /* FETCH_CATALOGO_ESTADOS_SUCCESS */], resp.data.estados);
    localStorage.setItem('listaEstados', __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_json_stringify___default()(resp.data.estados));
  }).catch(function (err) {
    console.log(err);
  });
});
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_routes_json__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_routes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_routes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_RootView__ = __webpack_require__(186);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
function createRouter(store) {
  function route(path, view, fullscreen, props, children) {
    var hasChildren = Array.isArray(children);
    return {
      path: path,
      meta: {
        fullscreen: fullscreen
      },
      name: hasChildren ? undefined : view,
      props: props,
      component: function component() {
        return __webpack_require__(189)("./".concat(view, "Page.vue"));
      },
      children: hasChildren ? children.map(function (r) {
        return route(r.route, r.page, r.fullscreen, r.props, r.children);
      }) : []
    };
  }
  var routes = __WEBPACK_IMPORTED_MODULE_2__data_routes_json___default.a.map(function (r) {
    return route(r.route, r.page, r.fullscreen, r.props, r.children);
  });
  routes.unshift({
    path: '/',
    name: 'home/Home',
    meta: {
      fullscreen: true
    },
    component: function component() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 96));
    }
  });
  var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_3__components_views_RootView__["a" /* default */],
      children: routes
    }, {
      path: '/login',
      name: 'Login',
      component: function component() {
        return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 95));
      }
    }, {
      path: '/inscripciones/especialidad',
      name: 'inscripciones/Especialidad',
      component: function component() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 97));
      }
    }]
  });
  router.beforeEach(function (to, from, next) {
    var isAuthenticated = store.getters['isAuthenticated'];
    if (to.meta.fullscreen || from.meta.fullscreen) {
      // store.commit('app/FULLSCREEN', !!to.meta.fullscreen)
    }
    if (to.name === 'inscripciones/Reinscripcion' && isAuthenticated) {
      var profile = store.getters['getProfile'];
      if (profile.semestre >= profile.semestreEspecialidad && !profile.especialidad) {
        next('/inscripciones/especialidad');
      }
    }
    if (to.path !== '/login' && !isAuthenticated) {
      next('/login');
    } else {
      next();
    }
  });
  return router;
}

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

module.exports = [{"route":"information/personal","page":"information/Personal"},{"route":"information/familiar","page":"information/Familiar"},{"route":"information/socioeconomica","page":"information/Socioeconomica"},{"route":"information/trabajo","page":"information/Trabajo"},{"route":"information/servicio-social","page":"information/ServicioSocial"},{"route":"information/servicio-social-descargas","page":"information/ServicioSocialDescargas"},{"route":"information/servicio-social-reportes","page":"information/ServicioSocialReportes"},{"route":"information/residencia-profesional","page":"information/ResidenciaProfesional"},{"route":"information/residencia-profesional-descargas","page":"information/ResidenciaProfesionalDescargas"},{"route":"information/boleta","page":"information/Boleta"},{"route":"information/horario","page":"information/Horario"},{"route":"information/kardex","page":"information/Kardex"},{"route":"information/avance-reticular","page":"information/AvanceReticular"},{"route":"information/calificaciones-parciales","page":"information/CalificacionesParciales"},{"route":"information/instrumentacion-didactica","page":"information/InstrumentacionDidactica"},{"route":"information/gestion-curso","page":"information/GestionCurso"},{"route":"inscripciones/reinscripcion","page":"inscripciones/Reinscripcion"},{"route":"inscripciones/referencia-bancaria","page":"inscripciones/ReferenciaBancaria"},{"route":"inscripciones/grupos-disponibles","page":"inscripciones/GruposDisponibles"},{"route":"inscripciones/extra-escolar","page":"inscripciones/ExtraEscolar"},{"route":"inscripciones/verano","page":"inscripciones/Verano"},{"route":"evaluacion-docente/evaluacion-docente","page":"evaluacion-docente/EvaluacionDocente"},{"route":"evaluacion-docente/evaluaciones-realizadas","page":"evaluacion-docente/EvaluacionesRealizadas"},{"route":"doctos-oficiales/solicitar","page":"doctos-oficiales/Solicitar"},{"route":"doctos-oficiales/consultar","page":"doctos-oficiales/Consultar"},{"route":"encuesta-servicios","page":"EncuestaServicios"},{"route":"buzon","page":"Buzon"}]

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RootView_vue_vue_type_template_id_4d14c7d6_scoped_true___ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RootView_vue_vue_type_script_lang_js___ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(16);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__RootView_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__RootView_vue_vue_type_template_id_4d14c7d6_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__RootView_vue_vue_type_template_id_4d14c7d6_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "4d14c7d6",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_RootView_vue_vue_type_template_id_4d14c7d6_scoped_true___ = __webpack_require__(188);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_RootView_vue_vue_type_template_id_4d14c7d6_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_RootView_vue_vue_type_template_id_4d14c7d6_scoped_true___["b"]; });


/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-1"},[_c('router-view')],1)
}
var staticRenderFns = []



/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./BuzonPage.vue": [
		198,
		30
	],
	"./EncuestaServiciosPage.vue": [
		199,
		22
	],
	"./EvaluacionDocentePage.vue": [
		200,
		29
	],
	"./LoginPage.vue": [
		95,
		1
	],
	"./doctos-oficiales/ConsultarPage.vue": [
		201,
		21
	],
	"./doctos-oficiales/SolicitarPage.vue": [
		202,
		20
	],
	"./evaluacion-docente/EvaluacionDocentePage.vue": [
		203,
		6
	],
	"./evaluacion-docente/EvaluacionesRealizadasPage.vue": [
		204,
		15
	],
	"./home/HomePage.vue": [
		96,
		0
	],
	"./information/AvanceReticularPage.vue": [
		205,
		19
	],
	"./information/BoletaPage.vue": [
		206,
		28
	],
	"./information/CalificacionesParcialesPage.vue": [
		207,
		27
	],
	"./information/FamiliarPage.vue": [
		208,
		13
	],
	"./information/GestionCursoPage.vue": [
		209,
		26
	],
	"./information/HorarioPage.vue": [
		210,
		18
	],
	"./information/InstrumentacionDidacticaPage.vue": [
		211,
		25
	],
	"./information/KardexPage.vue": [
		212,
		10
	],
	"./information/PersonalPage.vue": [
		213,
		3
	],
	"./information/ResidenciaProfesionalDescargasPage.vue": [
		214,
		17
	],
	"./information/ResidenciaProfesionalPage.vue": [
		215,
		8
	],
	"./information/ServicioSocialDescargasPage.vue": [
		216,
		16
	],
	"./information/ServicioSocialPage.vue": [
		217,
		11
	],
	"./information/ServicioSocialReportesPage.vue": [
		218,
		9
	],
	"./information/SocioeconomicaPage.vue": [
		219,
		5
	],
	"./information/TrabajoPage.vue": [
		220,
		12
	],
	"./inscripciones/EspecialidadPage.vue": [
		97,
		2
	],
	"./inscripciones/ExtraEscolarPage.vue": [
		221,
		7
	],
	"./inscripciones/GruposDisponiblesPage.vue": [
		222,
		24
	],
	"./inscripciones/ReferenciaBancariaPage.vue": [
		223,
		14
	],
	"./inscripciones/ReinscripcionPage.vue": [
		224,
		4
	],
	"./inscripciones/VeranoPage.vue": [
		225,
		23
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 189;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerValidSW;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(4);


var notifyUserAboutUpdate = function notifyUserAboutUpdate(worker) {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["m" /* NEW_UPDATE */], {
    text: 'Hay una nueva actualización disponible, recarga por favor.'
  });
};
function registerValidSW(swUrl) {
  navigator.serviceWorker.register(swUrl).then(function (registration) {
    if (registration.waiting) {
      console.log('New content has been available from last session; please refresh.');
      notifyUserAboutUpdate(registration.waiting);
      return;
    }
    registration.onupdatefound = function () {
      var installingWorker = registration.installing;
      installingWorker.onstatechange = function () {
        if (installingWorker.state === 'installed') {
          if (navigator.serviceWorker.controller) {
            // At this point, the fresh content will have been added to the cache.
            // It's the perfect time to display a "New content is
            // available; please refresh." message in your web app.
            console.log('New content is available; please refresh.');
            notifyUserAboutUpdate(installingWorker);
          } else {
            // At this point, everything has been precached.
            // It's the perfect time to display a
            // "Content is cached for offline use." message.
            console.log('Content is cached for offline use.');
          }
        }
      };
    };
  }).catch(function (error) {
    console.error('Error during service worker registration:', error);
  });
}

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DRAWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DRAWER_TOGGLE; });
/* unused harmony export FULLSCREEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_CATALOGO_ESTADOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_CATALOGO_ESTADOS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_CATALOGO_ESTADOS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NEW_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PUSH_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PUSH_NOTIFICATION_UNSUBSCRIBE; });
// APP
var DRAWER = 'DRAWER';
var DRAWER_TOGGLE = 'DRAWER_TOGGLE';
var FULLSCREEN = 'FULLSCREEN';

// Auth
var AUTH_REQUEST = 'AUTH_REQUEST';
var AUTH_SUCCESS = 'AUTH_SUCCESS';
var AUTH_LOGOUT = 'AUTH_LOGOUT';
var AUTH_ERROR = 'AUTH_ERROR';

// User
var FETCH_USER = 'FETCH_USER';
var FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
var FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

// Catalogs
var FETCH_CATALOGO_ESTADOS = 'FETCH_CATALOGO_ESTADOS';
var FETCH_CATALOGO_ESTADOS_SUCCESS = 'FETCH_CATALOGO_ESTADOS_SUCCESS';
var FETCH_CATALOGO_ESTADOS_FAILURE = 'FETCH_CATALOGO_ESTADOS_FAILURE';

// NOTIFICATION
var NEW_UPDATE = 'NEW_UPDATE';

// PUSH NOTIFICATIONS
var PUSH_NOTIFICATION = 'PUSH_NOTIFICATION';
var PUSH_NOTIFICATION_UNSUBSCRIBE = 'PUSH_NOTIFICATION_UNSUBSCRIBE';

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___ = __webpack_require__(60);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_promise__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_core_AppDrawer__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_core_AppToolbar__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_core_AppView__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_mutation_types__ = __webpack_require__(4);





function ownKeys(e, r) { var t = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default()(e); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default.a) { var o = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default()(e); r && (o = o.filter(function (r) { return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty___default()(e, r, t[r]); }) : __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default.a ? Object.defineProperties(e, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default()(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(t, r)); }); } return e; }







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppView: __WEBPACK_IMPORTED_MODULE_10__components_core_AppView__["a" /* default */],
    AppToolbar: __WEBPACK_IMPORTED_MODULE_9__components_core_AppToolbar__["a" /* default */],
    AppDrawer: __WEBPACK_IMPORTED_MODULE_8__components_core_AppDrawer__["a" /* default */]
  },
  created: function created() {
    var app = this;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.response.use(undefined, function (err) {
      return new __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_promise___default.a(function (resolve, reject) {
        if (err.request.status === 401 && err.config && !err.config.__isRetryRequest || !app.isAuthenticated) {
          // if you ever get an unauthorized, logout the user
          app.$store.dispatch(__WEBPACK_IMPORTED_MODULE_11__store_mutation_types__["b" /* AUTH_LOGOUT */]);
          app.$router.push('/login');
        }
        throw err;
      });
    });
  },
  data: function data() {
    return {
      showNotice: false
    };
  },
  props: {
    source: String
  },
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['isAuthenticated']))
});

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppDrawer_vue_vue_type_script_lang_js___ = __webpack_require__(78);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppDrawer_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_promise__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_layout_app_drawer_items__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_helpers__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);






function ownKeys(e, r) { var t = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default()(e); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default.a) { var o = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default()(e); r && (o = o.filter(function (r) { return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty___default()(e, r, t[r]); }) : __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default.a ? Object.defineProperties(e, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default()(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(t, r)); }); } return e; }





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppDrawer',
  data: function data() {
    return {
      items: __WEBPACK_IMPORTED_MODULE_7__data_layout_app_drawer_items__["a" /* default */]
    };
  },
  computed: _objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapState */])({
    appDrawer: function appDrawer(state) {
      return state.app.appDrawer;
    },
    isPushEnabled: function isPushEnabled(state) {
      return state.app.pushNotificationEnabled;
    }
  })), {}, {
    inputValue: {
      get: function get() {
        return this.appDrawer;
      },
      set: function set(value) {
        this.drawer(value);
      }
    }
  }),
  mounted: function mounted() {
    this.initialiseServiceWorker();
  },
  methods: _objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapMutations */])({
    drawer: 'DRAWER'
  })), {}, {
    logout: function logout() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["b" /* AUTH_LOGOUT */]);
      this.$router.push('/login');
    },
    genChildTarget: function genChildTarget(item, subItem) {
      if (subItem.href) return;
      return {
        name: "".concat(item.group, "/").concat(Object(__WEBPACK_IMPORTED_MODULE_9__util_helpers__["a" /* camel */])(subItem.name))
      };
    },
    initialiseServiceWorker: function initialiseServiceWorker() {
      var _this = this;
      if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
        console.log('Notifications aren\'t supported.');
        return;
      }
      if (Notification.permission === 'denied') {
        console.log('The user has blocked notifications.');
        return;
      }
      if (!('PushManager' in window)) {
        console.log('Push messaging isn\'t supported.');
        return;
      }
      navigator.serviceWorker.ready.then(function (registration) {
        registration.pushManager.getSubscription().then(function (subscription) {
          if (!subscription) {
            return;
          }
          _this.$store.commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["n" /* PUSH_NOTIFICATION */], true);
        }).catch(function (e) {
          console.log('Error during getSubscription()', e);
        });
      });
    },
    /**
     * Subscribe for push notifications.
     */
    subscribe: function subscribe() {
      var _this2 = this;
      navigator.serviceWorker.ready.then(function (registration) {
        var options = {
          userVisibleOnly: true
        };
        var vapidPublicKey = 'BC4ArJJJqzMHUPtzREd2nxTA6sIiFduzWjrwkb321wI0Qgb5aEtmafSTFTEZ1tU0pL26YMcTTF9j801CN15SfSs';
        if (vapidPublicKey) {
          options.applicationServerKey = _this2.urlB64ToUint8Array(vapidPublicKey);
        }
        registration.pushManager.subscribe(options).then(function (subscription) {
          _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["n" /* PUSH_NOTIFICATION */], true);
          _this2.updateSubscription(subscription);
        }).catch(function (e) {
          if (Notification.permission === 'denied') {
            console.log('Permission for Notifications was denied');
          } else {
            console.log('Unable to subscribe to push.', e);
          }
        });
      });
    },
    /**
     * Unsubscribe from push notifications.
     */
    unsubscribe: function unsubscribe() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["o" /* PUSH_NOTIFICATION_UNSUBSCRIBE */]);
    },
    /**
     * Send a request to the server to update user's subscription.
     *
     * @param {PushSubscription} subscription
     */
    updateSubscription: function updateSubscription(subscription) {
      var key = subscription.getKey('p256dh');
      var token = subscription.getKey('auth');
      var data = {
        endpoint: subscription.endpoint,
        key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
        token: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null
      };
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post('/alumno/subscriptions', data);
    },
    /**
     * Toggle push notifications subscription.
     */
    togglePush: function togglePush() {
      var _this3 = this;
      this.askPermission().then(function () {
        console.log(_this3.isPushEnabled);
        if (_this3.isPushEnabled) {
          _this3.unsubscribe();
        } else {
          _this3.subscribe();
        }
      });
    },
    // convert applicationServerPublicKey
    urlB64ToUint8Array: function urlB64ToUint8Array(base64String) {
      var padding = '='.repeat((4 - base64String.length % 4) % 4);
      var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
      var rawData = window.atob(base64);
      var outputArray = new Uint8Array(rawData.length);
      for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    },
    askPermission: function askPermission() {
      return new __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_promise___default.a(function (resolve, reject) {
        var permissionResult = Notification.requestPermission(function (result) {
          resolve(result);
        });
        if (permissionResult) {
          permissionResult.then(resolve, reject);
        }
      }).then(function (permissionResult) {
        if (permissionResult !== 'granted') {
          throw new Error('We weren\'t granted permission.');
        }
      });
    }
  })
});

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppToolbar_vue_vue_type_script_lang_js___ = __webpack_require__(80);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppToolbar_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(4);





function ownKeys(e, r) { var t = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default()(e); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default.a) { var o = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default()(e); r && (o = o.filter(function (r) { return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty___default()(e, r, t[r]); }) : __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default.a ? Object.defineProperties(e, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default()(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(t, r)); }); } return e; }


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppToolbar',
  data: function data() {
    return {
      user: {
        avatar: null,
        name: 'Usuario'
      }
    };
  },
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])({
    isPushEnabled: function isPushEnabled(state) {
      return state.app.pushNotificationEnabled;
    }
  })),
  methods: {
    logout: function logout() {
      var _this = this;
      if (this.isPushEnabled) {
        this.unsubscribe();
      }
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["b" /* AUTH_LOGOUT */]).then(function () {
        _this.$router.push('/login');
      });
    },
    /**
     * Unsubscribe from push notifications.
     */
    unsubscribe: function unsubscribe() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["o" /* PUSH_NOTIFICATION_UNSUBSCRIBE */]);
    }
  }
});

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppView_vue_vue_type_script_lang_js___ = __webpack_require__(82);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppView_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(17);





function ownKeys(e, r) { var t = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default()(e); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default.a) { var o = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default()(e); r && (o = o.filter(function (r) { return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_defineProperty___default()(e, r, t[r]); }) : __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default.a ? Object.defineProperties(e, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default()(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(t, r)); }); } return e; }

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppView',
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])({
    newUpdate: function newUpdate(store) {
      return store.app.newUpdate;
    },
    showNewUpdateMessage: function showNewUpdateMessage(store) {
      return store.app.showNewUpdateMessage;
    }
  })),
  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    }
  }
});

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules__ = __webpack_require__(177);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: __WEBPACK_IMPORTED_MODULE_2__store_modules__["a" /* default */]
}));

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RootView_vue_vue_type_script_lang_js___ = __webpack_require__(85);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RootView_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RootView'
});

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_mq__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_es6_promise_auto__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_router_sync__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_analytics__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__registerServiceWorker__ = __webpack_require__(195);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_mq__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
var router = Object(__WEBPACK_IMPORTED_MODULE_6__router__["a" /* createRouter */])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_9_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], router);
if (true) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_analytics___default.a, {
    id: 'UA-125627631-1',
    router: router
  });
}

/* Axios default URL */
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = "https://estudiantes.tuxtla.tecnm.mx/api";
var token = localStorage.getItem('token');
if (token) {
  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types__["j" /* FETCH_USER */]);
}
Object(__WEBPACK_IMPORTED_MODULE_12__registerServiceWorker__["a" /* registerValidSW */])('service-worker.js');

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  router: router,
  components: {
    App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]
  },
  template: '<App/>'
});

/***/ })

},[98]);


// WEBPACK FOOTER //
// static/js/app.d81646f1e691af602224.js